import { Link, useNavigate } from "react-router-dom";
import { useAuth, ROLE_LABELS } from "@/auth";
import { Button } from "@/components/ui/button";
import { LogOut } from "lucide-react";

export default function AppHeader({ rightSlot }) {
  const { user, subaccount, logout } = useAuth();
  const nav = useNavigate();
  return (
    <header className="sticky top-0 z-40 bg-white/90 backdrop-blur-md border-b border-slate-200" data-testid="app-header">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to={user?.role === "super_admin" ? "/super-admin" : "/dashboard"} className="flex items-center gap-2" data-testid="brand-link-app">
          <div className="w-8 h-8 bg-slate-900 grid place-items-center rounded">
            <span className="text-white font-display font-black text-lg">W</span>
          </div>
          <div>
            <div className="font-display font-bold text-slate-900 text-base leading-none">
              Noctua 360
            </div>
            <div className="text-[10px] uppercase tracking-[0.2em] text-slate-500">
              {subaccount ? subaccount.name : "Panel central"}
            </div>
          </div>
        </Link>
        <div className="flex items-center gap-3">
          {rightSlot}
          <div className="hidden sm:flex flex-col items-end leading-tight">
            <span className="text-sm font-medium text-slate-900" data-testid="header-user-name">{user?.name}</span>
            <span className="text-[10px] uppercase tracking-[0.2em] text-slate-500" data-testid="header-user-role">
              {ROLE_LABELS[user?.role] || user?.role}
            </span>
          </div>
          <Button
            variant="outline"
            size="sm"
            onClick={() => {
              logout();
              nav("/");
            }}
            className="border-slate-300"
            data-testid="logout-button"
          >
            <LogOut className="w-4 h-4 mr-2" /> Salir
          </Button>
        </div>
      </div>
      <div className="brand-stripe" />
    </header>
  );
}
